export const footer = {
    appDescription: "Mit DMARCFlow behalten Unternehmen die Kontrolle über ihre E-Mail-Sicherheit. Die Plattform bietet eine einfache Möglichkeit, DMARC-, SPF- und DKIM-Einträge zu verwalten, Reports zu analysieren und potenzielle Risiken frühzeitig zu erkennen.",
    navigation: {
        title: "Navigation",
        entries: {
            home: "Home",
            dmarc: "DMARC",
            spf: "SPF",
            dkim: "DKIM",
            bimi: "BIMI",
            pricing: "Preise"
        }
    },
    contact: {
        title: "Kontakt",
        email: "E-Mail",
        phone: "Telefon",
        address: "Adresse"
    },
    company: "Ucar Solutions UG",
    imprint: "Impressum",
    privacy: "Datenschutzerklärung"
}